var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper",class:_vm.classObj},[_c('sidebar',{staticClass:"sidebar-container"}),_c('div',{staticClass:"main-container"},[_c('NavbarNobread',{attrs:{"imgSrc":_vm.imgSrc == null?'https://dss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3510986481,3852924315&fm=111&gp=0.jpg':_vm.imgSrc}}),_c('app-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }